import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../Home/Home.css';
import '../Auth.css';

const MIN_PASSWORD_LENGTH = 12;

function Signup({ onSignup }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hasOverride = searchParams.has('override');

  const handleSignup = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(hasOverride ? '/api/signup?override=1' : '/api/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('siteId', data.siteId);
        onSignup(data.token);
        history.push('/onboarding');
      } else {
        setMessage(data.message || 'Signup failed');
      }
    } catch (error) {
      setMessage('An error occurred during signup');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Verify Email</h1>
        <form onSubmit={handleSignup}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            minLength={MIN_PASSWORD_LENGTH}
            required
          />
          <p>Password must be at least 12 characters and include uppercase, lowercase, and a number.</p>
          <button type="submit">Verify Email</button>
        </form>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
}

export default Signup;
